import DollarSign from '../Icons/Dollar Sign.svg';
import Euro from '../Icons/Euro.svg';

const lookup = {
    USD: DollarSign,
    EUR: Euro
};

export default lookup;
